import { encode } from 'base-64';
import { httpPostFetch, httpGetFetch, getData, httpGetDowntTimeFetch } from './Util';
import { webservices } from './Constants';
import * as constant from "./Constants";

export const selectParty = async (payload: {
  mobileNo: string;
  partyId: string;
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.selectParty,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in selectParty:', error);
    throw error;
  }
};

// ─── Helper: fetch both token and DBType together ───────────────────────────
const getAuthHeaders = async (): Promise<{ token: string; dbType: string }> => {
  const [tokenData, dbType] = await Promise.all([
    getData('token'),
    getData('DBType'),
  ]);
  return {
    token: tokenData ?? '',
    dbType: dbType ?? '',
  };
};

// ─── No auth needed (pre-login), only DBType after getDBType is called ──────

export const fetchAppVersionURL = async () => {
  try {
    const { token, dbType } = await getAuthHeaders();

    return httpGetFetch(webservices.getVersionUrl, token, dbType);
  } catch (error) {
    console.error(error);
  }
};

export const fetchDBtype = async (mobileNumber: string) => {
  try {
    const queryParams = `?MobileNo=${mobileNumber}`;
    return await httpGetFetch(webservices.getDBType + queryParams);
  } catch (error) {
    //console.log(error);
  }
};

export const fetchValidateMobileNo = async (
  mobileNumber: string,
  deviceID: string,
) => {
  try {
    const dbType = await getData('DBType');
    const queryParams = `?Mobileno=${encodeURIComponent(
      encode(mobileNumber),
    )}&DeviceID=${encodeURIComponent(encode(deviceID))}`;
    return await httpGetFetch(
      webservices.getValidateMobileNoUrl + queryParams,
      undefined,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchValidateMobileNo:', error);
    throw error;
  }
};

export const fetchGenerateOTP = async (payload: any) => {
  try {
    const dbType = await getData('DBType');
    return await httpPostFetch(
      webservices.getGenerateOTPUrl,
      payload,
      undefined,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchGenerateOTP:', error);
    throw error;
  }
};

export const fetchConfirmOTP = async (payload: {
  mobileno: string;
  deviceID: string;
  otp: string;
}) => {
  try {
    const dbType = await getData('DBType');
    return await httpPostFetch(
      webservices.getConfirmOTPUrl,
      payload,
      undefined,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchConfirmOTP:', error);
    throw error;
  }
};

// ─── Post-login: both token + DBType ─────────────────────────────────────────

export const fetchDealerList = async (mobileNumber: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?MobileNo=${encodeURIComponent(encode(mobileNumber))}`;
    return await httpGetFetch(
      webservices.getDealerList + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchDealerList:', error);
    throw error;
  }
};

export const getUserInfo = async (dealerId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    // const queryParams = `?CUST_ID=${encodeURIComponent(encode(dealerId))}`;
    return await httpGetFetch(
      webservices.getUserInfo,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in getUserInfo:', error);
    throw error;
  }
};

export const savingProfile = async (payload: any) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.SavingProfile,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in savingProfile:', error);
    throw error;
  }
};

export const populateMenu = async (dealerId: string, mobileno: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?mobileNo=${encodeURIComponent(mobileno)}`;
    return await httpGetFetch(
      webservices.PopulateMenu + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in populateMenu:', error);
    throw error;
  }
};

export const login = async(payload: {
  mobileno: string,
  actiontype: string,
  latitude: string,
  longitude: string,
  sourcE_TYPE: string,
  mpin: string,
  enteredby: string,
  otp: string,
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.getLoginMpin,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in login:', error);
    throw error;
  }
};

export const checkDelink = async (
  dealerId: string,
  mobileNo: string,
  deviceId: string,
) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?MobileNo=${encodeURIComponent(
      encode(mobileNo),
    )}&DeviceID=${encodeURIComponent(encode(deviceId))}`;
    return await httpGetFetch(
      webservices.getProfileDlinkChk + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in getUserInfo:', error);
    throw error;
  }
};
// ─── Logout ───────────────────────────────────────────────────────────────────
export const logOut = async(payload: {
  mobileNo: string,
  deviceID: string,
  actionType: string,
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const res = await httpPostFetch(
      webservices.logOut,
      payload,
      token,
      dbType,
    );
    return res;
  } catch (error) {
    console.error('Logout failed:', error);
    throw error;
  }
};

export const fetchSetMPINndLocation = async (payload: {
  mobileno: string;
  deviceID: string;
  latitude: string;
  longitude: string;
  isdevauthenable: string;
  mpin: string;
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.getSetMPINndLocation,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchSetMPINndLocation:', error);
    throw error;
  }
};

export const fetchDelinkStatus = async (payload: {
  mobileno: string;
  deviceID: string;
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.getDelink,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchDelinkStatus:', error);
    throw error;
  }
};

export const loginMPIN = async (payload: {
  mobileno: string;
  deviceID: string;
  mpin: string;
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.getLoginMpin,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchDelinkStatus:', error);
    throw error;
  }
};

export const generateTokenBio = async (payload: any) => {
  try {
    const { dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.getTokenBio,
      payload,
      '',
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchDelinkStatus:', error);
    throw error;
  }
};

export const fetchHomeKPI = async () => {
  try {
    const { token, dbType } = await getAuthHeaders();
    let dbTypes = dbType.concat('-REPORT')
    return await httpGetFetch(
      webservices.getGetAllHomeKPI,
      token,
      dbTypes,
    );
  } catch (error) {
    console.error('Error in fetchHomeKPI:', error);
    throw error;
  }
};

export const fetchViewCart = async (partyId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?PARTY_ID=${encodeURIComponent(partyId)}`;
    return await httpGetFetch(
      webservices.getViewCart + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchViewCart:', error);
    throw error;
  }
};

export const fetchListOfRecommendedProduct = async (custId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    // const queryParams = `?CUST_ID=${encodeURIComponent(encode(custId))}`;
    return await httpGetFetch(
      webservices.getListOfRecomendedproduct,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchListOfRecommendedProduct:', error);
    throw error;
  }
};

export const fetchListOfRecommendedProductLevel = async (
  custId: string,
  brandLevel: string,
) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?Brand_Level=${brandLevel}`;
    return await httpGetFetch(
      webservices.getListOfRecomendedproduct + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchListOfRecommendedProduct:', error);
    throw error;
  }
};

export const fetchListOfTradesSchemeInfo = async (custId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    // const queryParams = `?CUST_ID=${encodeURIComponent(encode(custId))}`;
    return await httpGetFetch(
      webservices.getListOfTradesScheme,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchListOfRecommendedProduct:', error);
    throw error;
  }
};

export const fetchListOfRecomProducts = async (
  code: string,
  custId: string,
) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?SCHEME_CODE=${encodeURIComponent(
      encode(code),
    )}`;
    return await httpGetFetch(
      webservices.getListOfRecomProducts + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchListOfRecommendedProduct:', error);
    throw error;
  }
};

export const fetchSaveAddToCart = async (payload: {
  partY_ID: string;
  proD_ID: string;
  iteM_COUNT: string;
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.getSaveAddtoCart,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in saveAddToCart:', error);
    throw error;
  }
};

export const deleteCartItem = async (payload: {
  partY_ID: string;
  proD_ID: string;
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.DeleteCartItem,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in saveAddToCart:', error);
    throw error;
  }
};

export const fetchCartCount = async (custId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?PARTY_ID=${encodeURIComponent(encode(custId))}`;
    return await httpGetFetch(
      webservices.getCartCount + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchListOfRecommendedProduct:', error);
    throw error;
  }
};

export const fetchOrderList = async (custId: string, fromDate: string, toDate: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?FROM_DATE=${encodeURIComponent(encode(fromDate))}&TO_DATE=${encodeURIComponent(encode(toDate))}`;
    return await httpGetFetch(
      webservices.GetAllOrder + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchOrderList:', error);
    throw error;
  }
};
export const fetchSchemeDetails = async (custId: string, prodId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?PROD_ID=${encodeURIComponent(encode(prodId))}`;
    return await httpGetFetch(
      webservices.getSchemeDetails + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchSchemeDetails:', error);
    throw error;
  }
};

export const fetchProductSchemeMetrics = async (custId: string, prodId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?PROD_ID=${encodeURIComponent(encode(prodId))}`;
    return await httpGetFetch(
      webservices.getProductSchemeMetrics + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchProductSchemeMetrics:', error);
    throw error;
  }
};

export const fetchInvoiceList = async (custId: string, soNo: string, fromDate: string, toDate: string) => {
//export const fetchInvoiceList = async (custId: string, soNo: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    // const queryParams = `?TYPE=${encodeURIComponent(encode('INVOICE'))}&CUST_ID=${encodeURIComponent(
    //   encode(custId),
    // )}&SOHD_SO_NO=${encodeURIComponent(encode(soNo))}`;
    const queryParams = `?TYPE=${encodeURIComponent(encode('INVOICE'))}&SOHD_SO_NO=${encodeURIComponent(encode(soNo))}&FROM_DATE=${encodeURIComponent(encode(fromDate))}&TO_DATE=${encodeURIComponent(encode(toDate))}`;

    return await httpGetFetch(
      webservices.GetAllOrder + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchInvoiceList:', error);
    throw error;
  }
};

export const invoiceDownload = async (payload: any) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.InvoiceDownload,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in InvoiceDownload:', error);
    throw error;
  }
};

export const fetchCartQuantity = async (custId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    // const queryParams = `?CUST_ID=${encodeURIComponent(encode(custId))}`;
    return await httpGetFetch(
      webservices.GetAllOrder,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchListOfRecommendedProduct:', error);
    throw error;
  }
};

export const saveOrder = async (payload: any) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.SaveOrderInfo,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in SaveOrderInfo:', error);
    throw error;
  }
};

export const saveToWishlist = async (payload: {
  partY_ID: string;
  producT_ID: string;
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.SavingWishlistItem,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in saveToWishlist:', error);
    throw error;
  }
};

export const fetchFavoriteItems = async (partyId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?PARTY_ID=${encodeURIComponent(encode(partyId))}`;
    return await httpGetFetch(
      webservices.GettingFavItems + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchFavoriteItems:', error);
    throw error;
  }
};

export const deleteFromWishlist = async (payload: {
  partY_ID: string;
  proD_ID: string;
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.DeleteWishlistItem,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in deleteFromWishlist:', error);
    throw error;
  }
};

export const fetchFetchingSimilarProducts = async (
  custId: string,
  prodId: string,
) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?PROD_ID=${encode(prodId)}`;
    return await httpGetFetch(
      webservices.FetchingSimilarProducts + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchFetchingSimilarProducts:', error);
    throw error;
  }
};

export const saveReOrder = async (payload: {
  ordeR_ID: string;
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.SaveReOrder,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in saveReOrder:', error);
    throw error;
  }
};

export const fetchBannerImage = async (custId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    // const queryParams = `?CUST_ID=${encodeURIComponent(encode(custId))}`;
    return await httpGetFetch(
      webservices.GetBannerImage,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchBannerImage:', error);
    throw error;
  }
};

export const saveCartBannerAction = async (payload: {
  partY_ID: string;
  banneR_ID: string;
  imG_ID: string;
}) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.CartBannerItem,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in CartBannerItem:', error);
    throw error;
  }
};

export const fetchFetchingCMS = async (typeId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?TYPE_ID=${encode(typeId)}`;
    return await httpGetFetch(
      webservices.FetchingCMS + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchFetchingCMS:', error);
    throw error;
  }
};

export const fetchRecommendedProductsTimeWise = async (custId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    // const queryParams = `?CUST_ID=${encode(custId)}`;
    return await httpGetFetch(
      webservices.RecommendedProductsTimeWise,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchRecommendedProductsTimeWise:', error);
    throw error;
  }
};

export const fetchSaved = async (partyId: string, type: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?TYPE=${encodeURIComponent(encode(type))}`;
    return await httpGetFetch(
      webservices.GetTimeWiseKpiDetails + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchSaved:', error);
    throw error;
  }
};

export const fetchSuggested = async (partyId: string, type: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?TYPE=${encodeURIComponent(encode(type))}`;
    return await httpGetFetch(
      webservices.GetCNFOCSuggestions + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchSuggested:', error);
    throw error;
  }
};

export const fetchTransactions = async (
  partyId: string,
  type: string,
  startDate: string,
  endDate: string,
) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?TYPE=${encodeURIComponent(encode(type))}&FROM_DATE=${encodeURIComponent(
      encode(startDate),
    )}&TO_DATE=${encodeURIComponent(encode(endDate))}`;
    return await httpGetFetch(
      webservices.TxnDetails + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in TxnDetails:', error);
    throw error;
  }
};

export const fetchOldInvoices = async (
  type: string,
  startDate: string,
  endDate: string,
) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const queryParams = `?TYPE=${encodeURIComponent(encode(type))}&FROM_DATE=${encodeURIComponent(
      encode(startDate),
    )}&TO_DATE=${encodeURIComponent(encode(endDate))}`;
    return await httpGetFetch(
      webservices.TxnDetailsByPID + queryParams,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in TxnDetails:', error);
    throw error;
  }
};

export const fetchProductsPinCodeWise = async (custId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    // const queryParams = `?CUST_ID=${encode(custId)}`;
    return await httpGetFetch(
      webservices.ProductsPinCodeWise,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchRecommendedProductsTimeWise:', error);
    throw error;
  }
};

export const fetchGetRunningSchemeProduct = async (custId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    // const queryParams = `?CUST_ID=${encode(custId)}`;
    return await httpGetFetch(
      webservices.GetRunningSchemeProduct,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchRecommendedProductsTimeWise:', error);
    throw error;
  }
};

export const fetchDownloadTransaction = async (payload: any) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    return await httpPostFetch(
      webservices.GetPdfTransPrint,
      payload,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchDownloadTransaction:', error);
    throw error;
  }
};

export const searchKeywords = async (custId: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    // const queryParams = `?CUST_ID=${encode(custId)}`;
    return await httpGetFetch(
      webservices.HotPickItems,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in HotPickItems:', error);
    throw error;
  }
};

export const countCheck = async (pageName: string, eventName: string) => {
  try {
    const { token, dbType } = await getAuthHeaders();
    const deviceData = await getData('deviceData');
    const data = await getData('userData');
    const partyId = data?.PARTY_ID ?? null;

    const inputData = {
      pvcPAGE_NAME: encode(pageName),
      pvcEVENT_NAME: encode(eventName),
      pvcMST_USER_ID: encode(partyId),
      pvcdevicE_ID: encode(deviceData?.DeviceID),
    };
    return httpPostFetch(
      webservices.SaveNavigationHistory,
      inputData,
      token,
      dbType,
    );
  } catch (error) {
    console.error('Error in fetchDelinkStatus:', error);
    throw error;
  }
};

export const fetchDowntime = async () => {
  try {
    return await httpGetDowntTimeFetch(constant.rootUrl + webservices.Downtime);
  } catch (error) {
    console.error(error);
  }
};
